function e(o, r) {
  console.error(`[vueuc/${o}]: ${r}`);
}
export {
  e as warn
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/shared/warn.js
// module id = 1787
// module chunks = 67